import React, { useState, useEffect, useRef } from 'react';
import 'iconify-icon';

const LoadingIntro = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const rafRef = useRef(0);

  useEffect(() => {
    // Fixed-duration progress driven by rAF (immune to setInterval throttling
    // when the main thread is busy with initial paint / canvas warm-up).
    const DURATION = 700; // ms — target time to reach 100%
    const start = performance.now();

    const step = (now) => {
      const elapsed = now - start;
      const pct = Math.min(100, Math.round((elapsed / DURATION) * 100));
      setProgress(pct);
      if (pct < 100) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        // Brief hold then fade out
        setTimeout(() => {
          setIsComplete(true);
          setTimeout(() => {
            onComplete && onComplete();
          }, 250);
        }, 120);
      }
    };

    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [onComplete]);

  if (isComplete) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] bg-[#0A0A0A] flex flex-col items-center justify-center transition-opacity duration-500 ${
        progress >= 100 ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Logo */}
      <div className="mb-8 scale-in">
        <img
          src="https://customer-assets.emergentagent.com/job_ie-interactive/artifacts/xbf78gkn_Simbolo_Laranja.png"
          alt="IE Eneagrama"
          className="h-24 w-auto animate-float"
        />
      </div>

      {/* Loading Bar */}
      <div className="w-64 h-1 bg-[#1F1F1F] rounded-full overflow-hidden">
        <div
          className="h-full bg-accent-orange transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      {/* Progress Text */}
      <div className="mt-6 flex items-center gap-2">
        <span className="text-xs font-mono uppercase tracking-[0.3em] text-neutral-500">
          Loading
        </span>
        <span className="text-xs font-mono font-bold text-accent-orange">
          {progress}%
        </span>
      </div>

      {/* Subtle Animation */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2">
        <div className="flex gap-2">
          <span className="w-2 h-2 bg-accent-orange rounded-full animate-bounce"></span>
          <span className="w-2 h-2 bg-accent-orange rounded-full animate-bounce delay-100"></span>
          <span className="w-2 h-2 bg-accent-orange rounded-full animate-bounce delay-200"></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingIntro;
